module.exports = __webpack_public_path__ + "42ac31e1a7d5831a996c3fdfd90ac812.svg";